export default function authHeader () {
  const user = localStorage.getItem('email')
  const accessToken = localStorage.getItem('token')
  const hash = localStorage.getItem('hash')
  if ((user && accessToken) || hash) {
    return {
      'Authorization': 'Bearer ' + accessToken,
      'ApiKey': process.env.VUE_APP_APIKEY
    }
  } else {
    return {}
  }
}
